/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";

interface Props {
  value: "left" | "right";
  heroMove: () => void;
  stopHero: () => void;
}

const TouchArea = ({ value, heroMove, stopHero }: Props) => {
  const [isPress, setIsPress] = useState(false);

  useEffect(() => {
    if (isPress) {
      heroMove();
    } else {
      stopHero();
    }
  }, [isPress]);

  return (
    <Container
      onContextMenu={(e: any) => {
        e.preventDefault();
      }}
      onMouseDown={() => {
        setIsPress(true);
      }}
      onMouseUp={() => {
        setIsPress(false);
      }}
      onMouseLeave={() => {
        setIsPress(false);
      }}
      onTouchStart={() => {
        setIsPress(true);
      }}
      onTouchEnd={() => {
        setIsPress(false);
      }}
    />
  );
};

export default TouchArea;

const Container = styled.div`
  flex: 1;
  /* background-color: pink; */
  height: 100%;
`;
